import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'

import { ConfigOptions } from '../common/app-config'

class InnerPage extends React.Component<
  {
    config: ConfigOptions
    isLoading: boolean
  } & RouteComponentProps<{}>,
  {}
> {
  render() {
    return (
      <div>
        <h2>Formularze</h2>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isLoading: state.loading.isLoading,
  config: state.ui.config,
})

export const PublicPage = connect(
  mapStateToProps,
  {},
)(InnerPage)

export default PublicPage
